export function openRegistrationForm() {
  const registrationPageLink = "https://lassie.ru/auth/?back_url=/detivlassie/";
  window.location = registrationPageLink;
}
